/**
 * 애드콘 API 화면 3곳(발행 현황·발송 테스트·계약 상품)과 공용 표가 같이 쓰는 클래스 문자열.
 * 버튼·칩 모양을 바꿀 때 여기 한 곳만 고친다.
 */
export const giftApiSmallButton =
  'inline-flex items-center rounded border border-gray-300 bg-white px-2.5 py-1 text-xs font-medium text-gray-700 hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-40';
export const giftApiPrimaryButton =
  'inline-flex items-center rounded border border-indigo-600 bg-indigo-600 px-2.5 py-1 text-xs font-semibold text-white hover:bg-indigo-700 disabled:cursor-not-allowed disabled:opacity-40';
export const giftApiDangerButton =
  'inline-flex items-center rounded border border-red-300 bg-white px-2.5 py-1 text-xs font-medium text-red-700 hover:bg-red-50 disabled:cursor-not-allowed disabled:opacity-40';
export const giftApiInput =
  'rounded border border-gray-300 px-2 py-1 text-sm focus:border-indigo-500 focus:outline-none';
export const giftApiChip =
  'inline-flex items-center rounded px-1.5 py-0.5 text-xs font-medium ring-1';
